import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import { DyeingMachine } from '@app/models/dyeing-dashboard/dyeing-machine';

@Injectable({
  providedIn: 'root',
})
export class DyeingMachineProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/dyeing-machine';

  public getAllMachines(): Observable<ApiResponse<DyeingMachine[]>> {
    return this.httpClient.get<ApiResponse<DyeingMachine[]>>(`${this.baseUrl}/all`);
  }

  public getMachineById(idMachine: string): Observable<ApiResponse<DyeingMachine>> {
    return this.httpClient.get<ApiResponse<DyeingMachine>>(`${this.baseUrl}/${idMachine}`);
  }
}
